import { render, staticRenderFns } from "./GoodsCateList.vue?vue&type=template&id=504e41c6&"
import script from "./GoodsCateList.vue?vue&type=script&lang=js&"
export * from "./GoodsCateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports